import { Pagination } from './Pagination';

export type { TypePaginationProps } from './types';
export default Pagination;
